import React from 'react';
import { mockCases } from '../data/mockData';

export default function Dashboard({ onCaseClick, onViewCases }) {
    const totalCases = mockCases.length;
    const overdueCases = mockCases.filter(c => c.daysOverdue > 30).length;
    const recoveryRate = Math.round((mockCases.filter(c => c.status === 'Closed').length / totalCases) * 100);
    const inProgressCases = mockCases.filter(c => c.status === 'In Progress').length;

    const dcaPerformance = {
        'DCA #1': { total: 15, recovered: 12, rate: 80 },
        'DCA #2': { total: 12, recovered: 8, rate: 67 },
        'DCA #3': { total: 10, recovered: 7, rate: 70 },
    };

    const casesByAge = {
        '0-15 days': mockCases.filter(c => c.daysOverdue <= 15).length,
        '16-30 days': mockCases.filter(c => c.daysOverdue > 15 && c.daysOverdue <= 30).length,
        '30+ days': mockCases.filter(c => c.daysOverdue > 30).length,
    };

    return (
        <div className="dashboard">
            <h2>📊 Dashboard</h2>

            {/* KPI Cards */}
            <div className="kpi-cards">
                <div className="kpi-card">
                    <h3>{totalCases}</h3>
                    <p>Total Cases</p>
                </div>
                <div className="kpi-card alert">
                    <h3>{overdueCases}</h3>
                    <p>Overdue (30+ days)</p>
                </div>
                <div className="kpi-card success">
                    <h3>{recoveryRate}%</h3>
                    <p>Recovery Rate</p>
                </div>
                <div className="kpi-card">
                    <h3>{inProgressCases}</h3>
                    <p>In Progress</p>
                </div>
            </div>

            {/* Charts Section */}
            <div className="charts-section">
                <div className="chart-card">
                    <h3>📈 Cases by Age</h3>
                    <div className="simple-chart">
                        {Object.entries(casesByAge).map(([label, count]) => (
                            <div key={label} className="chart-bar">
                                <span className="label">{label}</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: `${(count / totalCases) * 100}%` }}></div>
                                    <span className="value">{count}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="chart-card">
                    <h3>👥 DCA Performance</h3>
                    <div className="simple-chart">
                        {Object.entries(dcaPerformance).map(([dca, data]) => (
                            <div key={dca} className="chart-bar">
                                <span className="label">{dca}</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: `${data.rate}%`, backgroundColor: '#4CAF50' }}></div>
                                    <span className="value">{data.rate}%</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Status Distribution */}
            <div className="status-section">
                <h3>📋 Status Distribution</h3>
                <div className="status-grid">
                    <div className="status-item">
                        <span>🔵 Assigned</span>
                        <strong>{mockCases.filter(c => c.status === 'Assigned').length}</strong>
                    </div>
                    <div className="status-item">
                        <span>🟡 In Progress</span>
                        <strong>{mockCases.filter(c => c.status === 'In Progress').length}</strong>
                    </div>
                    <div className="status-item">
                        <span>🟢 Closed</span>
                        <strong>{mockCases.filter(c => c.status === 'Closed').length}</strong>
                    </div>
                </div>
            </div>

            <button className="view-cases-btn" onClick={onViewCases}>View All Cases →</button>
        </div>
    );
}
